import React from 'react'

import { RvAsset } from 'containers/ApplicationSubmissionForms/RVApplication/convertCollateralValues'
import styled from 'styled-components'
import { formatCurrency } from 'utils/formatCurrency'

import { typography } from '../../assets/styles'
import { SeperationLine, LinkStyle } from './VehicleSelectionBase.styled'

const ContainerStyle = styled.div`
    margin-bottom: 20px;
    > div {
        margin-top: 20px;
    }
    > div:first-child {
        margin-top: 0px;
    }
`

const VehicleStyle = styled.div`
    ${typography.Copy16Bold}
`

interface RvVehicleWriteInDetailProps {
    readonly onEdit: () => void
    readonly onReset: () => void
    readonly vehicle: RvAsset
}

export default function RvVehicleWriteInDetail({
    onEdit,
    onReset,
    vehicle,
}: RvVehicleWriteInDetailProps) {
    const { asset_value: assetValue, make, model, year } = vehicle ?? {}

    return (
        <ContainerStyle>
            <div>Your Vehicle Write-In</div>
            <VehicleStyle>
                <div>{`${year} ${make} ${model}`}</div>
                <div>{formatCurrency(assetValue)}</div>
            </VehicleStyle>
            <div>
                <LinkStyle type="button" onClick={onEdit}>
                    Edit this manual vehicle information
                </LinkStyle>
            </div>
            <SeperationLine />
            <div>
                Need to reset and select a different vehicle?{' '}
                <LinkStyle type="button" onClick={onReset}>
                    Reset / Select a new vehicle
                </LinkStyle>
            </div>
        </ContainerStyle>
    )
}
